/**
 * @generated SignedSource<<4698d8810221cf5bf07290709082a091>>
 * @relayHash fc40d3c8149ab222d1e4e3f5f1ef9d50
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f3860cec0f5646f48385c6749b0d059a8357dda0ae3f4b4070253d59519adfb4

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { FirstCreateViewQuery } from './FirstCreateViewQuery.graphql';

const node: PreloadableConcreteRequest<FirstCreateViewQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "f3860cec0f5646f48385c6749b0d059a8357dda0ae3f4b4070253d59519adfb4",
    "metadata": {},
    "name": "FirstCreateViewQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
